// material-ui
import { Grid, Box } from "@mui/material";

//other libraries
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// project imports
import { dateFormatDetails } from "qubCommon/helperMethods/dateHelper";
import ButtonLogin from "components/Buttons/ButtonLogin";
import { login } from "store/authReducer";
import * as styles from "./LoginStyles";
import LoginLogo from "assets/images/freedom_logo.png";
import { useModal, ModalImages, ModalButtons } from "context/modalContext";
import TextInput from "qubCommon/Inputs/TextInput";
import { FormProvider, useForm } from "react-hook-form";
import { storeMenu } from "store/menuReducer";

//Api Related imports
import { getGenApiData } from "api/auth";
import { apiDataKeyLogin } from "api/ApiDatakeys";
import { menuKeyDashboard } from "api/MenuKeys";
import { useRef } from "react";
import { handleOpen } from "store/menuReducer";
import { authorizedGenApiCall } from "api/genApiCalls";
import { apiDataKeyGetMenu } from "api/ApiDatakeys";

// ==============================|| WRAPPER ||============================== //

const Login = () => {
  const { openModal } = useModal();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginForm = useForm();
  const pwRef = useRef();

  const successfulLogin = async (res) => {
    const dataObject = JSON.parse(res?.data);
    await dispatch(
      login({
        userId: res?.userId,
        token: res?.token,
        sessionGuid: res?.sessionGuid,
        userName: dataObject?.userName,
        userFullName: dataObject?.userFullName,
        userMail: dataObject?.userMail,
        dateFormat: dateFormatDetails(dataObject?.dateFormat),
      })
    );
    const menu = await authorizedGenApiCall({
      dataKey: apiDataKeyGetMenu,
      parameters: [
        {
          dataKey: "ProjectKey",
          dataValue: "eShop",
        },
      ],
    });
    try {
      const menuParsed = JSON.parse(menu?.data);
      dispatch(storeMenu(menuParsed));
    } catch {
      console.log("menu-error");
    }
  };

  const errorLogin = (res) => {
    openModal({
      title: "Login",
      message: res?.data,
      imageType: ModalImages.Warning,
      buttons: ModalButtons.OK,
      callback: () => {},
    });
  };

  const attemptLogin = async (data) => {
    const res = await getGenApiData({
      dataKey: apiDataKeyLogin,
      parameters: JSON.stringify([
        {
          dataKey: "username",
          dataValue: data?.username,
        },
        { dataKey: "password", dataValue: data?.password },
      ]),
    });
    return res;
  };

  const loginHandler = async (data) => {
    const res = await attemptLogin(data);
    if (res?.status === "OK") {
      await successfulLogin(res);
      dispatch(handleOpen(true));
    } else errorLogin(res);
  };

  return (
    <Grid
      container
      sx={{
        height: { xs: "auto", sm: "100%" },
        p: 1,
        m: 0,
        bgcolor: "#fefefe",
        justifyContent: "center",
        alignItems: "center",
        overflow: "auto",
      }}
    >
      <FormProvider {...loginForm}>
        <Grid container item sx={styles.whiteContentGrid}>
          <Grid
            item
            xs={12}
            container
            alignItems="center"
            justifyContent="center"
          >
            <Box
              component="img"
              sx={{ height: "80%" }}
              src={LoginLogo}
              alt="Xcelvations Logo"
            />
          </Grid>
          <Grid item xs={12}>
            {/* <Typography align="center" variant="h6">
              Bussiness Key ERP
            </Typography> */}
          </Grid>
          <Grid item xs={12} paddingTop={4}>
            <TextInput
              rowDirection
              id="username"
              name="username"
              label="Username"
              fullWidth
              labelWidth={80}
            />
          </Grid>
          <Grid item xs={12} marginTop={1}>
            <TextInput
              innerRef={pwRef}
              rowDirection
              onKeyPress={(e) => {
                if (e?.key === "Enter") loginForm.handleSubmit(loginHandler)();
              }}
              labelWidth={80}
              label="Password"
              id="password"
              name="password"
              type="password"
              fullWidth
            />
          </Grid>
          {/* <Grid item xs={12}>
            <Typography
              variant="subtitle2"
              color="secondary"
              sx={styles.forgotPasswordTypography}
            >
              Ξέχασα τον κωδικό πρόσβασης.
            </Typography>
          </Grid> */}
          <Grid item xs={12} sx={{ marginTop: 2 }}>
            <ButtonLogin handleClick={loginForm.handleSubmit(loginHandler)} />
          </Grid>
        </Grid>
      </FormProvider>
    </Grid>
  );
};

export default Login;
